import { useNavigate, useParams } from "react-router-dom";
import { Flex, Heading, Link } from "@aws-amplify/ui-react";
import { Helmet } from "react-helmet";
import React from "react";

import { generateClient } from "aws-amplify/api";

import { Schema } from "../../../amplify/data/resource";
import RoutineUpdateForm from "../../ui-components/RoutineUpdateForm";
import { FaArrowLeft } from "react-icons/fa6";
import { I18n } from "aws-amplify/utils";

const client = generateClient<Schema>();

type DanceStyle = Schema["DanceStyle"]["type"];

export default function RoutineUpdate() {
  const navigate = useNavigate();
  const [danceStyles, setDanceStyles] = React.useState<DanceStyle[]>([]);

  React.useEffect(() => {
    const danceStylesSub = client.models.DanceStyle.observeQuery().subscribe({
      next: ({ items }) => {
        setDanceStyles(items);
      },
    });
    return () => {
      danceStylesSub.unsubscribe();
    };
  }, []);

  const { id } = useParams();
  return (
    <Flex direction="column" gap="1rem">
      <Helmet>
        <title>Edit Routine</title>
      </Helmet>
      <Flex marginTop={"1rem"}>
        <Heading level={1}>{I18n.get("Edit Routine")}</Heading>
      </Flex>
      <Flex>
        <Link onClick={() => navigate(-1)}>
          <FaArrowLeft aria-label={I18n.get("Back")} />
        </Link>
      </Flex>
      <Flex>
        <RoutineUpdateForm
          id={id}
          danceStyles={danceStyles}
          onSuccess={() => navigate(-1)}
        />
      </Flex>
    </Flex>
  );
}
